import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .cathy-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .cathy-content {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: calc(40rem / var(--default-rem-px-count));
      width: 100%;
      color: var(--block-text-color, #222);
    }

    .text-column {
      display: flex;
      flex-direction: column;
      gap: calc(30rem / var(--default-rem-px-count));
      width: 100%;
    }

    .title-desc {
      display: flex;
      flex-direction: column;
      gap: calc(30rem / var(--default-rem-px-count));
      width: 100%;
    }

    /* .title (h2) and .description (p) use the shared type defaults. */

    .cta {
      width: calc(221rem / var(--default-rem-px-count));
      max-width: 100%;
    }

    .image-column {
      width: 100%;
      display: flex;
    }

    .image-holder {
      background-color: #ececec;
      width: 100%;
      aspect-ratio: 356 / 237;
      overflow: hidden;
      display: flex;
    }

    .image-holder img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    @media (min-width: 600px) {
      .cathy-content {
        grid-column: 2 / 14;
        gap: calc(60rem / var(--default-rem-px-count));
      }

      .title-desc {
        flex-direction: row;
        gap: calc(20rem / var(--default-rem-px-count));
        align-items: baseline;
      }

      .title {
        flex: 1 1 0;
        min-width: 0;
        max-width: calc(356rem / var(--default-rem-px-count));
      }

      .description {
        flex: 1 1 0;
        min-width: 0;
      }

      .image-holder {
        aspect-ratio: auto;
        height: calc(460rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      .cathy-content {
        flex-direction: row;
        gap: calc(148rem / var(--default-rem-px-count));
        align-items: stretch;
      }

      .text-column {
        flex: 1 1 0;
        min-width: 0;
        max-width: calc(318rem / var(--default-rem-px-count));
        gap: calc(80rem / var(--default-rem-px-count));
      }

      .title-desc {
        flex-direction: column;
        gap: calc(40rem / var(--default-rem-px-count));
      }

      .title {
        max-width: none;
      }

      .image-column {
        flex: 1 1 0;
        min-width: 0;
        align-self: stretch;
      }

      .image-holder {
        flex: 1 1 auto;
        aspect-ratio: auto;
        height: auto;
        min-height: calc(494rem / var(--default-rem-px-count));
      }
    }
  `,
];
